export function getListItem(name, url, position) {
    var listItem = '      {\n' +
        '       "@type": "ListItem",\n' +
        '       "position":' + position + ',\n' +
        '       "item":\n' +
        '       {\n';
    if (url !== null) {
        listItem += '        "@id": "' + location.origin + url.split('?')[0] + '",\n';
    }
    listItem +=
        '        "name": "' + name + '"\n' +
            '        }\n' +
            '      }';
    return listItem;
}
export function getStructuredData(listItems) {
    return "{\n" +
        "     \"@context\": \"https://schema.org\",\n" +
        "     \"@type\": \"BreadcrumbList\",\n" +
        "     \"itemListElement\":\n" +
        "     [\n" + listItems +
        "     ]\n" +
        "    }";
}
